import { FormattedMessage } from 'react-intl';
import { Button, Text, Flex } from '@components';
import { useTheme } from '@mui/material';
import { boldenText } from '@utils/intl/intlUtils';

export interface NotificationSentProps {
  onResendNotification: () => void;
}

export const NotificationSent: React.FC<NotificationSentProps> = ({
  onResendNotification,
}) => {
  const theme = useTheme();

  return (
    <Flex
      flexDirection='column'
      pt={18}
      flex={1}
      alignItems='flex-start'
      gap={17}
    >
      <Text variant='h4' fontWeight='fontWeightBold'>
        <FormattedMessage id='login.notificationSent' />
      </Text>
      <Text
        variant='h5'
        fontWeight='fontWeightRegular'
        style={{
          color: theme.palette.black[700],
          marginTop: theme.spacing(3),
        }}
      >
        <FormattedMessage id='login.notificationSentExplanation' />
      </Text>
      <Text
        variant='h5'
        fontWeight='fontWeightRegular'
        style={{
          color: theme.palette.black[700],
          marginTop: theme.spacing(3),
        }}
      >
        <FormattedMessage
          id='login.notificationSentExplanationSecond'
          values={{
            b: (value) => (
              <span style={{ color: theme.palette.primary.main }}>
                {boldenText(value)}
              </span>
            ),
          }}
        />
      </Text>
      <Button
        data-testid='forgot-password-button'
        variant='secondary'
        color='primary'
        onClick={onResendNotification}
      >
        <FormattedMessage id='login.resendNotification' />
      </Button>
    </Flex>
  );
};
